export const copyright = `${new Date().getFullYear()} 地质灾害国家野外科学观测研究站`;

export const links = [
  {
    key: 'cug',
    title: '地大官网',
    href: 'http://www.cug.edu.cn',
    blankTarget: true,
  },
  {
    key: 'gcxy',
    title: '工程学院',
    href: 'http://gcxy.cug.edu.cn/',
    blankTarget: true,
  },
];
